<template>
  <div class="box">
    <p class="selectBox" :class=" { act : item.act } ">
      {{item.currency_short}} <span>{{item.amount}}</span>
      <i class="iconfont icon-shiliangzhinengduixiang"></i>
    </p>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'selectBox',
  props:{
    item: {
      type: Object,
      default: ()=> (
        {
          act : 0,
          currency_short: '',
          amount: ''
        }
      )
    }
  },
  computed: {

  },
  async mounted() {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>

.box{
  display: inline-block;
}
/* 选择框 */

.selectBox{
  position: relative;
  display: inline-block;
  padding: 3px 15px;
  border: 2px solid #dedede;
  cursor: pointer;
  user-select: none;
  >span{
    color: #f00;
    font-weight: 600;
  }
  i{
    position: absolute;
    font-size: 12px;
    right: 0;
    bottom: 0;
    color: #fff;
    z-index: 2;
  }
  &.act{
    border-color: $red_xi;
    &:after{
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      right: 0;
      bottom: 0;
      border: 10px solid;
      border-color: rgba(0,0,0,0) $red_xi $red_xi rgba(0,0,0,0);
    }
  }
}

/* 选择框 end*/
</style>